export const Create = () => import("./Create.vue");
export const Edit = () => import("./Edit.vue");
export const List = () => import("./List.vue");
export const CourseUsersList = () => import("./CourseUsersList.vue");
export const Users = () => import("./Users.vue");
export const UserTraining = () => import("./UserTraining.vue");
